<template>
    <div class="container-fluid layout-wrapper">



        <div class="row">
            <div class="card-body">
            </div>
            <div class="col-12">
                <div class="card shadow">
                    <div class="card-header admin-header">
                        <!--<h3 class="text-accent-light">پیام های کاربر</h3>-->
                        <button class="btn btn-primary btn-round" @click="onViewMessageClicked()">بازگشت به پیامها
                        </button>

                    </div>


                    <!--<div class="card-body">-->
                    <!--<div class="row">-->
                    <!--<div class="col-lg-6 col-sm-6 mb-3">-->

                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div class="card-body">-->
                    <!--<div class="row">-->
                    <!--<div class="col-lg-6 col-sm-6 mb-3">-->
                    <!--<div class="input-group round">-->
                    <!--<div class="input-group-prepend">-->
                    <!--<span class="input-group-text">نوع حساب</span>-->
                    <!--</div>-->
                    <!--<vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"-->
                    <!--:data="types" :mode="'create'"-->
                    <!--:header="{multiple: false, label: 'name'}"-->
                    <!--@onChange="onTypeChange">-->
                    <!--</vs-select>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div class="col-lg-6 col-sm-6 mb-3">-->
                    <!--<div class="input-group round">-->
                    <!--<div class="input-group-prepend">-->
                    <!--<span class="input-group-text">نوع عملیات</span>-->
                    <!--</div>-->
                    <!--<vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"-->
                    <!--:data="opType" :mode="'create'"-->
                    <!--:header="{multiple: false, label: 'name'}"-->
                    <!--@onChange="onOpTypeChange">-->

                    <!--</vs-select>-->
                    <!--</div>-->
                    <!--</div>-->

                    <!--<div class="col-lg-6 col-sm-6 mb-3">-->
                    <!--<div class="input-group round">-->
                    <!--<div class="input-group-prepend">-->
                    <!--<span class="input-group-text">از تاریخ</span>-->
                    <!--</div>-->
                    <!--<date-picker type="datetime" class="date-picker" format="jYYYY/jMM/jDD"-->
                    <!--@input="onFromDatePicked" ref="fromDate"-->
                    <!--style="flex: 1; display: flex;">-->
                    <!--<input class="form-control flex-grow-1 date-text-input" v-model="fromDate"-->
                    <!--@click="toggleFromDatePicker">-->
                    <!--</date-picker>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div class="col-lg-6 col-sm-6 mb-3">-->
                    <!--<div class="input-group round">-->
                    <!--<div class="input-group-prepend">-->
                    <!--<span class="input-group-text">تا تاریخ</span>-->
                    <!--</div>-->
                    <!--<date-picker type="datetime" class="date-picker" format="jYYYY/jMM/jDD"-->
                    <!--@input="onToDatePicked" ref="toDate"-->
                    <!--style="flex: 1; display: flex;">-->
                    <!--<input class="form-control flex-grow-1 date-text-input" v-model="toDate"-->
                    <!--@click="toggleToDatePicker">-->
                    <!--</date-picker>-->
                    <!--</div>-->
                    <!--</div>-->


                    <!--</div>-->

                    <!--<preloader v-if="isLoading"/>-->
                    <!--</div>-->

                    <!--<div v-if="!isLoading">-->
                    <!--<div class="table-responsive">-->

                    <!--<table class="table table-hover table-striped">-->
                    <!--<thead>-->
                    <!--<tr>-->
                    <!--<th>تاریخ</th>-->
                    <!--<th>پیام</th>-->
                    <!--<th>تاریخ ارسال</th>-->
                    <!--<th>وضعیت</th>-->
                    <!--<th>عملیات</th>-->

                    <!--</tr>-->
                    <!--</thead>-->
                    <!--<tbody>-->

                    <!--<tr v-for="it in messages">-->
                    <!--<td>{{it.prdate}}</td>-->
                    <!--<td><a @click="">{{it.message}}</a></td>-->
                    <!--<td>{{it.prdate2}}</td>-->
                    <!--<td>{{it.showStatus}}</td>-->
                    <!--<td class="text-center">-->
                    <!--<button class="btn btn-primary btn-round" @click="onViewMessageClicked(item.id)">مشاهده متن کامل پیام</button>-->
                    <!--</td>-->

                    <!--</tr>-->
                    <!--</tbody>-->
                    <!--</table>-->


                    <!--</div>-->

                    <!--</div>-->
                </div>
            </div>
            <!--<div class="row">-->
                <div class="col-lg-12 mb-4">
                    <div class="card shadow bg-info-grad">
                        <div class="card-body">
                            <div class="text-center">
                                <h4 class="text-white text-center mb-0">پیام های کاربر</h4>
                            </div>
                            <div>

                                <div class="row mt-3">
                                    <div class="col-sm-12 d-flex align-items-center justify-content-start">
                                        <div class="mb-3">
                                            <div class="" style="display: inline-grid">
                                                <span class="text-dark">متن پیام: </span>
                                                <strong class="m-2 text-white">{{messages.message}}</strong>
                                            </div>
                                            <div class="mt-4">
                                                <span class="text-dark">وضعیت: </span>
                                                <strong class="text-white">{{messages.showStatus}}</strong>
                                            </div>
                                            <div >
                                                <span class="text-dark">تاریخ ارسال: </span>
                                                <strong class="text-white">{{messages.prdate}}</strong>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            <!--</div>-->


        </div>

    </div>
</template>

<script>

    import BaseService from "../_framework/api/BaseService";
    import Utils from "../_framework/utils/Utils";
    import VsSelect from "../_framework/VsSelect";
    import DatePicker from "../_framework/vue-persian-datetime-picker/VuePersianDatetimePicker";
    import Moment from "moment-jalali";

    export default {
        name: "readmessage",
        components: {VsSelect, DatePicker},
        data() {
            return {
                isLoading: false,
                types: [{
                    id: 5,
                    name: "وام عادی"
                }],
                opType: [
                    {
                        id: 0,
                        name: "پرداختها"
                    },
                    {
                        id: 1,
                        name: "دریافتها"
                    },
                    {
                        id: 2,
                        name: "پرداختها و دریافتها"
                    },

                ],
                messages: [],


                reportModel: {
                    fromDate: "",
                    toDate: "",
                    type: 0,
                    isDebtor: null
                },
                fromDate: "",
                toDate: "",
                send_status: 0,
                show_status: 0,
                messageId: 0,
            }
        },
        mounted() {
            // this.getUserCompetitions();
            // this.getFields();
            // this.getProvinces();
            this.messageId = this.$route.params.id;
            this.getmessages();
        },
        methods: {
            getmessages() {
                this.isLoading = true;
                // new BaseService("Report",

                //     "/messages/fromDate=" + this.reportModel.fromDate + "/toDate=" + this.reportModel.toDate + "/type=" + this.reportModel.type + "/isDebtor=" + this.reportModel.isDebtor
                // ).getList().then(response => {
                new BaseService("MemberMessages", "/ReadCurrentMemberMessage/" + this.messageId).getList().then(response => {
                    this.isLoading = false;
                    this.messages = response.data.data;

                    this.messages.prdate = Moment(this.messages.createdOn, 'YYYY-MM-DD').format('jYYYY/jMM/jDD')
                    this.messages.prdate2 = Moment(this.messages.messageDate, 'YYYY-MM-DD').format('jYYYY/jMM/jDD')

                    // this.userMatchesPagination.currentPage = response.data.pageIndex + 1;
                    // this.userMatchesPagination.totalRows = response.data.count;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                })
            },


            toggleFromDatePicker() {
                this.$refs.fromDate.togglePicker();
            },
            onFromDatePicked(val) {
                this.reportModel.fromDate = this.jalaliToGregorian(val);
                this.fromDate = this.gregorianToJalaliBeautified(this.jalaliToGregorian(val), true);
                this.getmessages();
            },
            toggleToDatePicker() {
                this.$refs.toDate.togglePicker();
            },
            onToDatePicked(val) {
                this.reportModel.toDate = this.jalaliToGregorian(val);
                this.toDate = this.gregorianToJalaliBeautified(this.jalaliToGregorian(val), true);
                this.getmessages();
            },
            onPaymentConfirmed() {
                if (this.paymentMethod === "online") {
                    this.payOnline();
                }
                if (this.paymentMethod === "cash") {
                    this.payByCash();
                }
                if (this.paymentMethod === "wallet") {
                    this.payByWallet();
                }
            },

            onShowDiagramClicked(id) {
                this.tournamentBracketId = id;
                this.$refs.tournamentBracketModal.showModal();
            },

            validateDate(date) {
                return Moment(date, 'YYYY-MM-DD').format('jDD jMMMM jYYYY')
            },
            onTypeChange(val) {
                if (val !== null) {
                    this.reportModel.type = val.id;
                    this.getmessages();
                } else {
                    this.reportModel.type = 0;
                    this.getmessages();
                }
            },
            onOpTypeChange(val) {
                if (val !== null) {
                    switch (val.id) {
                        case 0:
                            this.reportModel.isDebtor = false;
                            this.getmessages();
                            break;
                        case  1:
                            this.reportModel.isDebtor = true;
                            this.getmessages();

                            break;
                        case  2:
                            this.reportModel.isDebtor = null;
                            this.getmessages();

                            break;
                    }

                } else {
                    this.reportModel.type = 0;
                    this.getmessages();
                }
            },
            onViewMessageClicked() {

                this.$router.push({

                    name: 'messages',

                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .payment-options-container {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        width: 100%;
        margin-top: 1.5rem;
    }

    .payment-option {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        background-color: #ffffff;
        border-radius: 0.25rem;
        padding: 0.5rem;
        box-shadow: 0 5px 15px -2px rgba(0, 0, 0, 0.5);
        border: 2px solid transparent;
        cursor: pointer;
        transition: all 0.3s;
    }

    .payment-option.active {
        border: 2px solid #40c4ff;
        box-shadow: 0 5px 15px -2px #40c4ff;
    }

    .payment-option img {
        max-width: 100px;
    }

    .payment-option small {
        color: #333333;
        margin-top: 0.5rem;
    }

    .wallet-payment-wrapper {
        height: 150px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>